import { OnlineInfoPc } from './OnlineInfo/OnlineInfo.pc';
import { OnlineInfoMobile } from './OnlineInfo/OnlineInfo.mobile';
import { useIsMobile } from '../../../hook/useIsMobile';

export const OnlineInfo = () => {
  const isMobile = useIsMobile();
  return isMobile ? <OnlineInfoMobile /> : <OnlineInfoPc />;
};
